import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { cgtag } from 'utilities/gtag';
import find from 'lodash/find';

interface Option {
  value: string | number;
  label: string;
}

interface DropDownListProps {
  name: string; // Used for analytics purposes only
  value: string | number;
  items: Option[];
  labelPrefix?: string;
  onChange: (event: { target: { value: React.SetStateAction<string | number> } }) => void;
}

const DropDownList: React.FC<DropDownListProps> = ({ name, value, items, onChange, labelPrefix }) => {
  return (
    <Select
      fullWidth
      variant="standard"
      value={value}
      onChange={(ev) => {
        cgtag('drop_down', {
          drop_down_name: name,
          selected_option: ev.target.value,
        });
        onChange(ev);
      }}
      IconComponent={ExpandMoreIcon}
      renderValue={(val) => {
        const currentItem = find(items, ['value', val]);
        if (labelPrefix) return labelPrefix + ' ' + currentItem?.label;
        return currentItem?.label;
      }}
    >
      {items.map((Item: Option, index: number) => (
        <MenuItem key={`dropdown${index}`} value={Item.value}>
          {Item.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DropDownList;
